import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";

type ConfirmArchiveFormulaModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isArchiving: boolean;
};

export const ConfirmArchiveFormulaModal = ({
  isOpen,
  onClose,
  onConfirm,
  isArchiving,
}: ConfirmArchiveFormulaModalProps) => (
  <ModalV2
    show={isOpen}
    onHide={onClose}
    title="Archive formula"
    size="small"
    visuallyHideTitle
    data-testid="confirm-archive-formula-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" alignItems="center" gap={SPACING.MEDIUM}>
        <Icon
          type="exclamation-triangle"
          size="xxx-large"
          color={Colors.Neutral600}
          variant="outline"
        />
        <Text variant="h2" color={Colors.Neutral900}>
          Archive formula
        </Text>
        <Text variant="secondary-md" align="center">
          Archiving this formula will remove it from all templates.
        </Text>
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="column" gap={SPACING.SMALL}>
        <Button
          variant="danger"
          onClick={onConfirm}
          isLoading={isArchiving}
          disabled={isArchiving}
          isFullWidth
          data-testid="confirm-archive-formula-button"
        >
          Archive
        </Button>
        <Button variant="neutral" onClick={onClose} disabled={isArchiving} isFullWidth>
          Cancel
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
